// extracted by mini-css-extract-plugin
export var pricingCard = "index-module--pricingCard--O1CXT";
export var pricingCard__title = "index-module--pricingCard__title--kiEEn";
export var pricingCard__price = "index-module--pricingCard__price--hI4YA";
export var pricingCard__text = "index-module--pricingCard__text--IfsvB";
export var pricingCard__btn = "index-module--pricingCard__btn--S9CO8";
export var pricingCard__features = "index-module--pricingCard__features--K78y-";
export var pricingCard__featuresText = "index-module--pricingCard__featuresText--6PND1";
export var pricingCard__featuresList = "index-module--pricingCard__featuresList--0oJW7";
export var pricingCard__featuresSubText = "index-module--pricingCard__featuresSubText--ZGabZ";